var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 304,
    viewBox: "0 0 390 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 2,
    fill: "#EEE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 131,
    width: 128,
    height: 128,
    rx: 2,
    fill: "#EEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 262,
    width: 128,
    height: 128,
    rx: 2,
    fill: "#EEE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 131,
    width: 128,
    height: 128,
    rx: 2,
    fill: "#EEE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 131,
    width: 128,
    height: 128,
    rx: 2,
    fill: "#EEE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 131,
    width: 128,
    height: 128,
    rx: 2,
    fill: "#EEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#2ok3dmyuya)",
    d: "M0 0h390v390H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "2ok3dmyuya",
    x1: 195,
    y1: -137.386,
    x2: 195,
    y2: 255.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPost);
export default __webpack_public_path__ + "static/media/EmptyPost.a428c8573addb4d299ef81bfe0742db8.svg";
export { ForwardRef as ReactComponent };